import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="ui--tabs"
export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = { storageKey: String }

  connect() {
    const persistedIndex = this.#persistedIndex()
    const selectedIndex =
      persistedIndex ?? this.tabTargets.findIndex((tab) => tab.getAttribute("aria-selected") === "true")
    this.showByIndex(selectedIndex >= 0 ? selectedIndex : 0)
  }

  select(event) {
    event.preventDefault()
    this.showByIndex(this.tabTargets.indexOf(event.currentTarget))
  }

  showByIndex(selectedIndex) {
    if (selectedIndex < 0 || selectedIndex >= this.tabTargets.length) selectedIndex = 0

    this.tabTargets.forEach((tab, index) => {
      const selected = index === selectedIndex
      tab.setAttribute("aria-selected", selected.toString())
      tab.classList.toggle("tab-active", selected)
    })

    this.panelTargets.forEach((panel, index) => {
      panel.classList.toggle("hidden", index !== selectedIndex)
    })

    if (this.hasStorageKeyValue) {
      sessionStorage.setItem(this.storageKeyValue, selectedIndex.toString())
    }
  }

  #persistedIndex() {
    if (!this.hasStorageKeyValue) return null

    const value = sessionStorage.getItem(this.storageKeyValue)
    if (value === null) return null

    const index = parseInt(value, 10)
    return Number.isNaN(index) ? null : index
  }
}
